import React from "react";
import MapPage from "./MapPage";
import ContactSection from "./ContactSection";
import "./ContactSection.css";

export default function ContactSection2() {
  return (
    <section>

      {/* =====================================================
          HERO
          הכותרת נשארת בדיוק כמו שביקשת
      ===================================================== */}

      <div
        className="ContactSection2-page"
        style={{
          position: "relative",
        }}
      >

        <div
          className="ContactSection2-hero"
          style={{
            position: "relative",
          }}
        >

          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              zIndex: 5,
              padding: "20px",
            }}
          >

            <h1
              style={{
                margin: 0,
                color: "#ffffff",
                fontSize: "clamp(32px, 6vw, 62px)",
                fontWeight: 900,
                lineHeight: 1.2,
                textShadow: "0 4px 15px rgba(0,0,0,0.85)",
                letterSpacing: "1px",
                direction: "rtl",
              }}
            >
              צרו איתנו קשר
            </h1>

          </div>

        </div>

      </div>


      {/* =====================================================
          CONTACT CONTENT
          השליחה נמצאת בתוך ContactSection
      ===================================================== */}

      <ContactSection />


      {/* =====================================================
          MAP
      ===================================================== */}
     
      <MapPage />

    </section>
  );
}
